var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_825_16103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.48972 12.166H46.8198L48.9951 14.5462H3.31445L5.48972 12.166Z",
    fill: "#87B1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97382 13.44H7.22513V12.779C7.01227 12.9598 6.77406 13.1185 6.51046 13.2549C6.0096 13.5018 5.45376 13.6251 4.84296 13.6251C4.00003 13.6251 3.24868 13.4215 2.589 13.0142C1.94153 12.6069 1.42847 12.0516 1.04976 11.3481C0.683276 10.6446 0.500002 9.84245 0.5 8.94149C0.5 8.0406 0.683272 7.23835 1.04976 6.53486C1.42847 5.83141 1.94154 5.27601 2.589 4.86873C3.24868 4.46147 4.00003 4.25788 4.84296 4.25788C5.45376 4.25788 6.00348 4.37509 6.49212 4.60957C6.74068 4.72594 6.96672 4.8651 7.17016 5.02706V0H9.97382V13.44ZM5.35603 6.81256C4.96511 6.81256 4.61694 6.90512 4.31153 7.09025C4.01834 7.27537 3.78012 7.5284 3.59688 7.84926C3.42585 8.17012 3.34034 8.53422 3.34034 8.94149C3.34034 9.34876 3.42585 9.71286 3.59688 10.0337C3.76791 10.3546 4.00613 10.6076 4.31153 10.7927C4.61694 10.9779 4.95899 11.0704 5.33769 11.0704C5.74083 11.0704 6.089 10.984 6.38219 10.8112C6.67537 10.6261 6.90747 10.3731 7.07853 10.0522C7.24954 9.73137 7.33508 9.36112 7.33508 8.94149C7.33508 8.52192 7.24954 8.15775 7.07853 7.84926C6.91969 7.5284 6.68759 7.27537 6.38219 7.09025C6.089 6.90512 5.74695 6.81256 5.35603 6.81256Z",
    fill: "#1637E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9951 14.5449H3.31445V15.9995H48.9951V14.5449Z",
    fill: "#1637E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_825_16103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.eda88da86fd95d7aca3796b1e651d7b7.svg";
export { ForwardRef as ReactComponent };